module.exports = __webpack_public_path__ + "img/gmail.0fee9056.png";